import React, { useState } from 'react';
import { runInAction } from 'mobx';
import { Brand } from '../lib/brand';
import { AuthStoreSync } from './AuthStoreSync';
import { RootStoreProps } from './RootStore';
import { RootStoreContext } from './RootStoreContext';
import initializeRootStore from './initializeRootStore';

type RootStoreProviderProps = {
    store?: RootStoreProps;
    brand: Brand;
};
export const RootStoreProvider: React.FC<React.PropsWithChildren<RootStoreProviderProps>> = ({ store, brand, children }) => {
    const [rootStore] = useState(() => initializeRootStore(store));
    runInAction(() => (rootStore.brand = brand));
    return (
        <RootStoreContext.Provider value={rootStore}>
            <AuthStoreSync />
            {children}
        </RootStoreContext.Provider>
    );
};
